<script>
  import {onMount, createEventDispatcher} from "svelte";
  export let open = false;

  let dispatcher = createEventDispatcher();

  function close() {
    dispatcher('close');
  }
</script>

<style>
  .fa-times {
    color: black;
    font-size: 20px;
  }
  .bg {
    position:fixed;
    top:0;
    left:0;
    width:100vw;
    height:100vh;
    background:rgba(0,0,0,.4);
  }
</style>

{#if open}
<div class="bg" on:click={close}></div>
<div class="bg-white !shadow !rounded-lg !divide-y {$$props.class || ''}" style="{$$props.style || ''}">

  <div class="!px-4 !py-5 !sm:px-6 !flex !items-center !justify-between">
    <slot name="title"></slot>
    <slot name="close" close={close}>
        <i class="fas fa-times" on:click={close}></i>
    </slot>
  </div>
  <div class="!px-4 !py-5 !sm:p-6">
    <slot name="content"></slot>
  </div>
</div>
{/if}
